import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';

import WithRender from './contract-data.component.html';
import contractTemplateService from '@/services/contractTemplateService';
import { EventBus, Events } from '@/event-bus';
import CancelRequestComponent from '@/components/dialog/cancel-request.component.vue';
import AmountComponent from '@/components/amount.component.vue';
import CityComponent from '@/components/city.component.vue';
import DropDownCalendarComponent from '@/components/dropDownCalendar.vue';
import EmailComponent from '@/components/email.component.vue';
import MobileComponent from '@/components/mobile.component.vue';
import NationalIdComponent from '@/components/nationalId.component.vue';
import NumberComponent from '@/components/number.component.vue';
import TextComponent from '@/components/text.component.vue';
import { ClauseTypeEnum } from '@/enums/ClauseTypeEnum';
import { ContractStatusEnum } from '@/enums/contract-status.enum';
import { ClauseForRequest, ClauseTextModel } from '@/models/clause.model';
import { ControlConditionModel } from '@/models/ControlConditionModel';
import { ClauseTemplateModel, TemplateModel } from '@/models/TemplateModel';
import { DDCalendarDate } from '@/models/common';
import { ContractClausesModel } from '@/models/contractClausesModel';
import { CreateContractModel } from '@/models/contractDetailsModel';
import { Toaster } from '@/services/toast';
import { moduleProxy } from '@/store';

export interface ConditionData {
  id: string;
  code: string;
  oldValue: string;
  newValue: string;
  controlId: string;
  isHighlight: boolean;
  componentName: string;
  isValid: boolean;
  length: number;
  clauseTextId: number;
  clauseOrder: number;
  featureId: number;
  name: string;
  order: number;
  disabled: boolean;
}

export interface ControlResult {
  value: any;
  index: number;
  isValid: boolean;
}

export interface ConractData {
  startData: DDCalendarDate;
  endDate: DDCalendarDate;
}

@WithRender
@Component({
  components: {
    NationalIdComponent,
    TextComponent,
    DropDownCalendarComponent,
    MobileComponent,
    AmountComponent,
    NumberComponent,
    EmailComponent,
    CityComponent,
  },
  diProvide: [
    contractTemplateService,
  ],
})
export default class ContractData extends Vue {
  @Inject(contractTemplateService) public contractTemplateService!: contractTemplateService;
  templateId!: number;
  templateModel: TemplateModel = {} as TemplateModel;
  valueTemplateModel: TemplateModel = {} as TemplateModel;
  preliminaryClause: ClauseTemplateModel = {} as ClauseTemplateModel;
  introductionClause: ClauseTemplateModel = {} as ClauseTemplateModel;
  clickedClause: ClauseTextModel = {} as ClauseTextModel;
  clickedCondition: ControlConditionModel = {} as ControlConditionModel;
  ConditionsData: ConditionData[] = [] as ConditionData[];
  selectedIndex = 0;
  socialId = '';
  testvalue = '';
  clausesText: ContractClausesModel[] = [] as ContractClausesModel[];

  created() {
    // Subscribe to an event.
    EventBus.$on(Events.Request.ConfirmCancelRequestEvent, () => {
      moduleProxy.Contract.clearContract();
      this.$router.push({ name: 'issueContract' });
    });
  }

  mounted() {
    if (moduleProxy?.Contract?.getTemplateId) {
      this.templateId = moduleProxy.Contract.getTemplateId;
    }

    const contract = { ...moduleProxy.Contract.getContract };
    const clausesText = { ...moduleProxy.Contract.getClausesText };

    if (contract.clauses && contract.clauses.length > 0) {
      this.mapTemplateFromStore(contract, clausesText);
    } else {
      this.getTemplateById();
    }
  }

  beforeDestroy() {
    // Unsubscribe from an event.
    EventBus.$off(Events.Request.ConfirmCancelRequestEvent);
  }

  mapTemplateFromStore(contract: CreateContractModel, clausesText: ContractClausesModel[]) {
    this.templateModel = contract as any;
    this.templateModel.name = contract.contractName;
    const prelClause = clausesText?.find((x) => x.clauseTypeId === ClauseTypeEnum.Preliminary);

    if (prelClause) {
      this.preliminaryClause = prelClause as any;
      this.templateModel.preliminary = contract.preliminaryLabel;
    }

    const introClause = clausesText?.find((x) => x.clauseTypeId === ClauseTypeEnum.Introduction);

    if (introClause) {
      this.introductionClause = introClause as any;
      this.templateModel.introduction = contract.introductionLabel;
    }

    this.templateModel.clauses = clausesText.filter((x) => x.clauseTypeId === ClauseTypeEnum.Clause) as any;

    setTimeout(() => {
      this.addClickEventToClauseCond();
      this.valueTemplateModel = { ...this.templateModel };
    }, 2000);
  }

  getTemplateById() {
    this.contractTemplateService.getTemplateById(this.templateId).then((response) => {
      this.templateModel = response.model;
      // مقدمة وتمهيد
      const prelClause = response?.model?.clauses?.find((x) => x.clauseTypeId === ClauseTypeEnum.Preliminary);
      if (prelClause) {
        this.preliminaryClause = prelClause;
        this.templateModel.preliminary = this.formatTextLabel(this.preliminaryClause.childClauses[0]);
      }

      const introClause = response?.model?.clauses?.find((x) => x.clauseTypeId === ClauseTypeEnum.Introduction);
      if (introClause) {
        this.introductionClause = introClause;
        this.templateModel.introduction = this.formatTextLabel(this.introductionClause.childClauses[0]);
      }

      this.templateModel.clauses = this.templateModel.clauses.filter((x) => x.clauseTypeId === ClauseTypeEnum.Clause);

      this.templateModel.clauses.forEach((x) => {
        x.childClauses?.map((txtItem) => {
          txtItem.labelText = this.formatTextLabel(txtItem);
          txtItem.childClauses?.map((subTxtItem) => {
            subTxtItem.labelText = this.formatTextLabel(subTxtItem);
          });
        });
      });

      setTimeout(() => {
        this.addClickEventToClauseCond();
        this.valueTemplateModel = { ...this.templateModel };
      }, 1000);
    });
  }

  formatTextLabel(item: any) {
    item.labelText = item.text;

    if (!item.controlConditions) {
      item.controlConditions = [];
    }

    item.controlConditions.forEach((cond: any) => {
      if (cond?.code?.includes('FirstPartner') || cond?.code?.includes('SecondPartner') || cond?.code?.includes('Lawyer')) {
        if (cond?.code?.includes('Lawyer')) {
          item.labelText = item.labelText.replaceAll(`(${cond.name})`, `<a id="cond_${cond.code}_${item.id}_${cond.name}_${cond.length}" class="cond-chip-disabled" data-feature-id="${cond.id}">${this.getStorePatner(3, cond.name)}</a>`);
          item.text = item.text.replaceAll(`(${cond.name})`, `${this.getStorePatner(3, cond.name)}`).replaceAll('<p>', '').replaceAll('</p>', '');
        } else if (cond?.code?.includes('SecondPartner')) {
          item.labelText = item.labelText.replaceAll(`(${cond.name})`, `<a id="cond_${cond.code}_${item.id}_${cond.name}_${cond.length}" class="cond-chip-disabled" data-feature-id="${cond.id}">${this.getStorePatner(2, cond.name)}</a>`);
          item.text = item.text.replaceAll(`(${cond.name})`, `${this.getStorePatner(2, cond.name)}`).replaceAll('<p>', '').replaceAll('</p>', '');
        } else {
          item.labelText = item.labelText.replaceAll(`(${cond.name})`, `<a id="cond_${cond.code}_${item.id}_${cond.name}_${cond.length}" class="cond-chip-disabled" data-feature-id="${cond.id}">${this.getStorePatner(1, cond.name)}</a>`);
          item.text = item.text.replaceAll(`(${cond.name})`, `${this.getStorePatner(1, cond.name)}`).replaceAll('<p>', '').replaceAll('</p>', '');
        }
      } else if (cond?.code?.includes('ContractStartDate') || cond?.code?.includes('ContractEndDate')) {
        if (cond?.code?.includes('ContractStartDate')) {
          item.labelText = item.labelText.replaceAll(`(${cond.name})`, `<a id="cond_${cond.code}_${item.id}_${cond.name}_${cond.length}" class="cond-chip-disabled" data-feature-id="${cond.id}">${this.getStoreContractDate(true, cond.name)}</a>`);
          item.text = item.text.replaceAll(`(${cond.name})`, `${this.getStoreContractDate(true, cond.name)}`).replaceAll('<p>', '').replaceAll('</p>', '');
        } else {
          item.labelText = item.labelText.replaceAll(`(${cond.name})`, `<a id="cond_${cond.code}_${item.id}_${cond.name}_${cond.length}" class="cond-chip-disabled" data-feature-id="${cond.id}">${this.getStoreContractDate(false, cond.name)}</a>`);
          item.text = item.text.replaceAll(`(${cond.name})`, `${this.getStoreContractDate(false, cond.name)}`).replaceAll('<p>', '').replaceAll('</p>', '');
        }
      } else {
        const highlightedTag = `<a id="cond_${`${cond.name}_${item.id}`}" class="cond-chip">${cond.name}</a>`;
        item.labelText = item.labelText.replaceAll(`(${cond.name})`, `<a id="cond_${cond.code}_${item.id}_${cond.name}_${cond.length}" class="cond-chip" data-feature-id="${cond.id}">${cond.name}</a>`);
        cond.index = (item.labelText as string).indexOf(highlightedTag);
      }
    });

    return item.labelText;
  }

  onConditionClicked(event: any) {
    if (event?.target?.id) {
      const id = event?.target?.id;
      const condition = this.ConditionsData.find((x) => x.id === id);
      this.ConditionsData.map((x) => x.isHighlight = false);
      if (condition) {
        condition.isHighlight = true;
        this.getLabelClass(condition);
      }
      const control = document.getElementById(`${condition?.controlId}`);
      if (control) {
        control.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  getClauseFromPreIntro(conditionData: ConditionData) {
    let clause = {} as any;
    let isPre = false;
    const el = document.getElementById(conditionData.id);
    this.preliminaryClause?.childClauses?.forEach((clauseText) => {
      if (clauseText.id === conditionData.clauseTextId) {
        clause = clauseText;
        isPre = true;
      } else {
        const child = clauseText.childClauses.find((y) => y.id === conditionData.clauseTextId);
        if (child) {
          clause = clauseText;
          isPre = true;
        }
      }
    });

    this.introductionClause?.childClauses?.forEach((clauseText) => {
      if (clauseText.id === conditionData.clauseTextId) {
        clause = clauseText;
        isPre = false;
      } else {
        const child = clauseText.childClauses.find((y) => y.id === conditionData.clauseTextId);
        if (child) {
          clause = child;
          isPre = false;
        }
      }
    });

    if (isPre) {
      if (el) {
        if (el.parentElement && (el.parentElement.parentElement?.id.includes('preliminary') || el.parentElement.id.includes('preliminary'))) {
          clause.text = el.parentElement.innerText;
          this.getLabelClass(conditionData);
          clause.labelText = el.parentElement.innerHTML;
        }
      }
    } else if (el) {
      if (el.parentElement && (el.parentElement.parentElement?.id.includes('introduction') || el.parentElement.id.includes('introduction'))) {
        clause.text = el.parentElement.innerText;
        this.getLabelClass(conditionData);
        clause.labelText = el.parentElement.innerHTML;
      }
    }
  }

  addClickEventToClauseCond() {
    const elements = document.querySelectorAll('a[class^=cond-chip]');
    let clauseId = 0;
    let clauseOrder = 0;

    Array.from(elements).forEach((el: any, index: any) => {
      if (el.hasAttributes()) {
        const elementId = el.attributes.getNamedItem('id').value;
        const disabled = el.classList.contains('cond-chip-disabled');

        if (elementId) {
          const id = `${elementId}_${index}`;
          const controlId = `${id}_control`;
          const lst = elementId.split('_');
          const code = lst[1];
          const clauseTextId = parseInt(lst[2], 10);
          const condName = lst[3];
          const length = parseInt(lst[4], 10);
          const newValue = el.innerText !== condName ? el.innerText : '';
          el.setAttribute('id', id);

          if (clauseId !== clauseTextId) {
            clauseOrder = 1;
            clauseId = clauseTextId;
          } else {
            clauseOrder += 1;
          }

          // fill array of conditions
          this.ConditionsData.push({
            id,
            code,
            newValue,
            oldValue: condName,
            controlId,
            isHighlight: false,
            componentName: this.getComponentName(code),
            isValid: true,
            length,
            clauseTextId,
            clauseOrder,
            featureId: Number(el.dataset.featureId),
            name: this.getElementName(code),
            disabled,
          } as ConditionData);
        }

        if (!disabled) {
          el.addEventListener('click', (event: PointerEvent) => {
            this.onConditionClicked(event);
          });
        }
      }
    });
  }

  controlDataChanged(controlResult: ControlResult) {
    const conditionsDataItem = this.ConditionsData[controlResult.index];
    conditionsDataItem.isValid = controlResult.isValid;
    const id = this.ConditionsData[controlResult.index]?.id;
    const el = document.getElementById(id);
    this.getLabelClass(conditionsDataItem);
    if (!conditionsDataItem?.code.includes('Date') && el) { // not date controls
      if (controlResult.isValid) {
        this.ConditionsData[controlResult.index].newValue = controlResult.value;

        el.innerText = this.ConditionsData[controlResult.index].newValue;
      } else {
        el.innerText = this.ConditionsData[controlResult.index].oldValue;
      }
    } else if (conditionsDataItem?.code.includes('Date') && controlResult.isValid) { // for date controls
      if (conditionsDataItem?.code.includes('gregorianDate') && controlResult.value.gregDate !== '') {
        this.ConditionsData[controlResult.index].newValue = controlResult.value.gregDate.replaceAll('-', '/');
        if (el) {
          el.innerText = this.ConditionsData[controlResult.index].newValue;
        }
      } else if (conditionsDataItem?.code.includes('HijriDate') && controlResult.value.hijriDate !== '') {
        this.ConditionsData[controlResult.index].newValue = controlResult.value.hijriDate.replaceAll('-', '/');
        if (el) {
          el.innerText = this.ConditionsData[controlResult.index].newValue;
        }
      }
    } else if (el) {
      el.innerText = this.ConditionsData[controlResult.index].oldValue;
    }
    this.setClauseValueTemplate(conditionsDataItem);
    this.getControlClass(conditionsDataItem);
  }

  getComponentName(code: string) {
    if (code.includes('text')) return 'TextComponent';
    if (code.includes('nationalId') || code.includes('iqama')) return 'NationalIdComponent';
    if (code.includes('HijriDate') || code.includes('gregorianDate')) return 'DropDownCalendarComponent';
    if (code.includes('mobile')) return 'MobileComponent';
    if (code.includes('amount')) return 'AmountComponent';
    if (code.includes('number')) return 'NumberComponent';
    if (code.includes('email')) return 'EmailComponent';
    if (code.includes('cities')) return 'CityComponent';
    return 'TextComponent';
  }

  private getElementName(code: string): string {
    if (code.includes('date')) return 'date';
    if (code.includes('text')) return 'text';
    if (code.includes('number')) return 'number';
    if (code.includes('time')) return 'time';
    if (code.includes('gregorianDate')) return 'gregorian';
    if (code.includes('HijriDate')) return 'hijri';
    if (code.includes('mobile')) return 'mobile';
    if (code.includes('email')) return 'email';
    if (code.includes('cities')) return 'city';
    if (code.includes('districts')) return 'district';
    if (code.includes('contries')) return 'country';
    if (code.includes('amount')) return 'amount';
    if (code.includes('nationalId')) return 'nationalId';
    if (code.includes('iqama')) return 'iqama';
    return 'text';
  }

  getControlClass(item: ConditionData) {
    let classes = '';
    if (item.isHighlight) {
      if (item.isValid) {
        classes = 'control-highlight';
      } else {
        classes = 'control-highlight-error';
      }
    }
    return classes;
  }

  getLabelClass(item: ConditionData) {
    this.ConditionsData.forEach((x) => {
      const el = document.getElementById(`${x.id}`);
      if (el) {
        el.classList.remove('cond-chip-highlighted');
      }
    });
    const el = document.getElementById(`${item.id}`);
    if (el) {
      if (item.newValue !== '' && item.isValid) {
        // success case
        el.classList.remove('cond-chip-error');
        el.classList.remove('cond-chip-highlighted');
        el.classList.add('cond-chip-success');
      } else if (!item.isValid) {
        el.classList.remove('cond-chip-highlighted');
        el.classList.remove('cond-chip-success');
        el.classList.add('cond-chip-error');
      } else if (item.isHighlight && item.isValid) {
        el.classList.remove('cond-chip-success');
        el.classList.remove('cond-chip-error');
        el.classList.add('cond-chip-highlighted');
      } else {
        el.classList.remove('cond-chip-success');
        el.classList.remove('cond-chip-error');
        el.classList.remove('cond-chip-highlighted');
      }
    }
  }

  clauseDataChanged(item: any) {
    console.log('clauseDataChanged', item);
  }

  setClauseValueTemplate(conditionData: ConditionData) {
    let clause = {} as any;
    this.valueTemplateModel.clauses.filter((x) => {
      x.childClauses.filter((x) => {
        if (x.id === conditionData.clauseTextId) {
          clause = x;
        } else {
          const child = x.childClauses.find((y) => y.id === conditionData.clauseTextId);
          if (child) {
            clause = child;
          }
        }
      });
    });
    const el = document.getElementById(conditionData.id);
    if (el && clause.text) {
      if (el.parentElement && el.parentElement.id.includes('clause')) {
        clause.text = el.parentElement.innerText;
        this.getLabelClass(conditionData);
        clause.labelText = el.parentElement.innerHTML;
      }
    } else {
      this.getClauseFromPreIntro(conditionData);
    }
  }

  validateForm(): boolean {
    const notValidCont = this.ConditionsData.find((x) => x.newValue === '' || x.isValid === false);
    if (notValidCont) {
      this.ConditionsData.map((c) => c.isHighlight = false);
      notValidCont.isHighlight = true;
      const control = document.getElementById(`${notValidCont.controlId}`);
      if (control) {
        control.scrollIntoView({ behavior: 'smooth' });
      }
      const message = 'الرجاء ملء الحقول المطلوبة';
      Toaster.error({ message });
      this.getLabelClass(notValidCont);
      return false;
    }
    return true;
  }

  mapTemplateToContract() {
    const contractClausesText: ContractClausesModel[] = this.valueTemplateModel.clauses;

    if (this.valueTemplateModel.preliminary && this.valueTemplateModel.preliminary !== '<p><br></p>') {
      let pre = contractClausesText.find((x) => x.clauseTypeId === ClauseTypeEnum.Preliminary);
      this.valueTemplateModel.preliminary = this.preliminaryClause.childClauses[0].labelText;
      this.valueTemplateModel.preliminaryText = this.preliminaryClause.childClauses[0].text;

      if (pre) {
        pre = this.preliminaryClause;
      } else {
        contractClausesText.push(this.preliminaryClause);
      }
    } else {
      this.valueTemplateModel.preliminary = null;
      this.valueTemplateModel.preliminaryText = null;
    }

    if (this.valueTemplateModel.introduction && this.valueTemplateModel.introduction !== '<p><br></p>') {
      let intro = contractClausesText.find((x) => x.clauseTypeId === ClauseTypeEnum.Introduction);
      this.valueTemplateModel.introduction = this.introductionClause.childClauses[0].labelText;
      this.valueTemplateModel.introductionText = this.introductionClause.childClauses[0].text;

      if (intro) {
        intro = this.introductionClause;
      } else {
        contractClausesText.push(this.introductionClause);
      }
    } else {
      this.valueTemplateModel.introduction = null;
      this.valueTemplateModel.introductionText = null;
    }

    moduleProxy.Contract.setContractClauses(this.createClausesForRequest(this.ConditionsData));
    moduleProxy.Contract.setContractClausesText(contractClausesText);
    moduleProxy.Contract.setContractPreliminary(this.valueTemplateModel.preliminary);
    moduleProxy.Contract.setContractPreliminaryText(this.valueTemplateModel.preliminaryText);
    moduleProxy.Contract.setContractIntroduction(this.valueTemplateModel.introduction);
    moduleProxy.Contract.setContractIntroductionText(this.valueTemplateModel.introductionText);
    moduleProxy.Contract.setContractName(this.valueTemplateModel.name);
    moduleProxy.Contract.setContractStatus(ContractStatusEnum.Pending);
    moduleProxy.Contract.setContractTemplate(this.valueTemplateModel.id);
  }

  /**
   * Generates contract clauses.
   * @param conditions A list of features conditions.
   * @returns A list of clauses.
   */
  private createClausesForRequest(conditions: ConditionData[]): ClauseForRequest[] {
    const clauses: ClauseForRequest[] = [];

    conditions.forEach((condition) => {
      const clause = clauses.find((clause) => clause.clauseId === condition.clauseTextId);
      const feature = { value: condition.newValue, orderInClause: condition.clauseOrder, featureTypeId: condition.featureId };
      if (clause) {
        clause.features.push(feature);
      } else {
        clauses.push({ clauseId: condition.clauseTextId, features: [feature] });
      }
    });

    return clauses;
  }

  onControlClicked(conditionData: ConditionData) {
    this.ConditionsData.map((x) => x.isHighlight = false);
    if (conditionData) {
      conditionData.isHighlight = true;
      this.getLabelClass(conditionData);
    }
    const label = document.getElementById(`${conditionData?.id}`);
    if (label) {
      label.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  getStorePatner(tarafTypeId: number, condName: string) {
    const contract = moduleProxy.Contract.getContract;
    let partnerName = condName;
    if (contract?.partners?.length > 0) {
      const partner = contract.partners.find((x) => x.partnerTarafTypeId === tarafTypeId);
      if (partner) {
        partnerName = `${partner.firstName} ${partner.fatherName} ${partner.grandFatherName} ${partner.familyName}`;
      }
    }
    return partnerName;
  }

  getStoreContractDate(isStartDate: boolean, condName: string) {
    const contract = moduleProxy.Contract.getContract;
    let date = condName;
    if (contract?.startDate) {
      if (isStartDate) {
        date = contract.startDate.isGregorian ? contract.startDate.gregDate : contract.startDate.hijriDate;
      } else {
        date = contract.endDate.isGregorian ? contract.endDate.gregDate : contract.endDate.hijriDate;
      }
    }
    return date.replaceAll('-', '/');
  }

  nextStep() {
    if (this.validateForm()) {
      this.mapTemplateToContract();
      this.$router.push({ name: 'previewContract' });
    }
  }

  previousStep() {
    this.$router.push({ name: 'contractDuration' });
  }

  /**
   * Initiate cancel request process.
   */
  onCancel(): void {
    // Publish an event.
    EventBus.$emit(Events.Dialog.OpenDialogEvent, CancelRequestComponent);
  }
}
